class Async3rdLoader {
  constructor(script, id) {
    this.script = script
    this.head = document.querySelector('head')
    this.target = document.createElement('script')
    if (id) this.target.id = id
  }

  load() {
    return new Promise((resolve, reject) => {
      this.target.src = this.script
      this.target.onload = (event) => resolve(event)
      this.target.onerror = (event) => {
        reject(new Error(`Failed to load ${event.target.src}`))
      }

      this.head.appendChild(this.target)
    })
  }
}

export default Async3rdLoader
